import "./src/styles/main.css"
import Provider from "./src/providers"

export const wrapRootElement = Provider
